import '#/assets/main.css';
import { InterfaceTab, IRCConnectionSettings } from '#/types/types';
import TabManager from '#/ui/tabManager';
import UIRenderer from '#/ui/uiRenderer';
import ClientEventManager from '#/clientEventManager';
import MessageHandler from '#/messageHandler';
import ConnectionHandler from '#/connectionHandler';
import CommandHandler from '#/commandHandler';
import { loadSettings } from '#/util/settings';

export interface IRCClient {
    tabs: Map<string, InterfaceTab>;
    activeTab: InterfaceTab | null;
    tabManager: TabManager;
    uiRenderer: UIRenderer;
    clientEventManager: ClientEventManager;
    messageHandler: MessageHandler;
    connectionHandler: ConnectionHandler;
    commandHandler: CommandHandler;
    settings: IRCConnectionSettings;
    isConnected: boolean;
}

class IRCClientImpl implements IRCClient {
    public tabs: Map<string, InterfaceTab>;
    public activeTab: InterfaceTab | null;
    public tabManager: TabManager;
    public uiRenderer: UIRenderer;
    public clientEventManager: ClientEventManager;
    public messageHandler: MessageHandler;
    public connectionHandler: ConnectionHandler;
    public commandHandler: CommandHandler;
    public settings: IRCConnectionSettings;

    constructor() {
        this.tabs = new Map<string, InterfaceTab>();
        this.activeTab = null;
        this.settings = loadSettings();

        this.tabManager = new TabManager(this);
        this.uiRenderer = new UIRenderer(this);
        this.clientEventManager = new ClientEventManager(this);
        this.messageHandler = new MessageHandler(this);
        this.connectionHandler = new ConnectionHandler(this);
        this.commandHandler = new CommandHandler(this);

        this.init();
    }

    private init(): void {
        this.uiRenderer.createContainer();
        this.uiRenderer.createTabBar();
        this.uiRenderer.createContentArea();
        this.tabManager.initialize();
        this.clientEventManager.initialize();
        this.connectionHandler.updateButtonStates();
    }

    get isConnected(): boolean {
        return this.connectionHandler?.isConnected || false;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    (window as any).ircClient = new IRCClientImpl();
});

export default IRCClientImpl;